import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { InstitutionsSliderRoutingModule } from './institutions-slider-routing.module';
import { InstitutionsSliderListComponent } from './institutions-slider-list/institutions-slider-list.component';
import { InstitutionsSliderCreateComponent } from './institutions-slider-create/institutions-slider-create.component';

@NgModule({
  declarations: [InstitutionsSliderListComponent, InstitutionsSliderCreateComponent],
  imports: [
    CommonModule,
    InstitutionsSliderRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class InstitutionsSliderModule { }
